import React, { useContext } from 'react';
import DocsPrivacy from './DocsPrivacy';
import { SettingsContext } from '../context';
import { useTranslation } from 'react-i18next';
import AgreementForm from './AgreementForm';

/**
 * Privacy Form, Step from @see AgreementsApprove
 * @param props
 */
export default function(props: {
  onChange: (checked: boolean) => void;
  value: boolean;
}) {
  const { language } = useContext(SettingsContext);
  const { t } = useTranslation();
  return (
    <AgreementForm
      label={t('agreementPrivacy')}
      onChange={props.onChange}
      value={props.value}
    >
      <DocsPrivacy lng={language || 'en'} />
    </AgreementForm>
  );
}
